// extracted by mini-css-extract-plugin
export default {"body":"Hisotry_body__gXZAU","footer":"Hisotry_footer__XhYCf","myButton":"Hisotry_myButton__joDm1","mod":"Hisotry_mod__felyO"};